import { makeSx } from '../../../theme/_utils'
import { defaultPalette } from '../../../theme/idsTheme'

export default makeSx({
    helpCenterMain: {
        maxWidth: '1616px',
        width: '100%',
        margin: '0 auto',
        marginTop: '2rem',
    },
    helpCenterMainTitle: {
        fontSize: '1.6rem',
        fontWeight: '800',
        paddingBottom: '8px',
        borderBottom: `1px solid ${defaultPalette.lightGrey.mediumDark}`,
    },
})
